import { SiteIds } from './../../models/sites';
import { AppConfig } from './../../app.config';
import { ISignInState } from './../../store/state/auth.signin.state';
import { getSignInState } from 'src/app/store/auth/selectors/auth.selectors';
import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { AuthService } from '../http/auth.service';


@Injectable()
export class RegisterAuthGuard  {
    constructor(private router: Router, public authService: AuthService, private appConfig: AppConfig) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const siteId = this.appConfig.appConfigSignal().env.siteId;
        if (siteId && siteId === SiteIds.INVESTNOW && this.authService.isLoggedIn()) {
            return of(true);
        } else if (siteId && siteId !== SiteIds.INVESTNOW) {
            return of(true);
        }
        this.router.navigate(['/auth/signin']);
    }
}
